// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__b6Hmj","col":"CardReaderDesc_col__ZU6Ox","label":"CardReaderDesc_label__LjUQH"};